var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { AccountTab, RoutePath, generateRoutePath } from '../../app/router/config';
import burnIcon from '../../assets/images/icons/common/icon-burn-red.png';
import cancelIcon from '../../assets/images/icons/common/icon-trash-purple.png';
import Table, { CellAlign, CellType } from '../../components/common/table';
import Header from '../../components/pending-actions/header';
import { DialogContext } from '../../context/dialog';
import { LoadingContext } from '../../context/loading';
import { UserContext } from '../../context/user';
import { useCheckbox } from '../../hooks/common/use-checkbox';
import Layout from '../../layout';
import { DialogType } from '../../types/dialogs';
import { getKeyFromEnum } from '../../utils/common';
import { formatDate } from '../../utils/date';
export default function PendingBurns() {
    var _a = useI18n(), t = _a.t, i18n = _a.i18n;
    var navigate = useNavigate();
    var setServerLoading = useContext(LoadingContext).setServerLoading;
    var setDialogProps = useContext(DialogContext).setDialogProps;
    var user = useContext(UserContext).user;
    var _b = useState(undefined), pendingBurns = _b[0], setPendingBurns = _b[1];
    var acceptTerms = useCheckbox(false);
    useEffect(function () {
        getPendingBurns();
    }, []);
    useEffect(function () {
        setDialogProps(function (value) {
            return (value === null || value === void 0 ? void 0 : value.custom.type) === DialogType.SIMPLE_WITH_CHECKBOX
                ? __assign(__assign({}, value), { common: __assign(__assign({}, value.common), { actions: value.common.actions && value.common.actions.length > 0
                            ? [__assign(__assign({}, value.common.actions[0]), { disabled: !acceptTerms.value })]
                            : undefined }), custom: __assign(__assign({}, value.custom), { checked: acceptTerms }) }) : value;
        });
    }, [acceptTerms]);
    function getPendingBurns() {
        return __awaiter(this, void 0, void 0, function () {
            var blockchainPendingBurnFindMany;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (user && (user === null || user === void 0 ? void 0 : user.mpcWalletAddress) && !(user === null || user === void 0 ? void 0 : user.magicLinkWalletAddress)) {
                            navigate(generateRoutePath(RoutePath.ACCOUNT, { tab: AccountTab.OVERVIEW }));
                            return [2 /*return*/];
                        }
                        setServerLoading(true);
                        if (!(pendingBurns === undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, gqlSdk.BlockchainPendingBurnFindMany()];
                    case 1:
                        blockchainPendingBurnFindMany = (_a.sent()).blockchainPendingBurnFindMany;
                        if (!blockchainPendingBurnFindMany) {
                            setPendingBurns([]);
                        }
                        else {
                            setPendingBurns(blockchainPendingBurnFindMany);
                        }
                        _a.label = 2;
                    case 2:
                        setServerLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function showCancelPendingBurnDialog(uuid) {
        setDialogProps({
            common: {
                title: t('pending-burn.cancel.title'),
                close: { text: t('common.back'), action: hideDialog },
                actions: [
                    { highlighted: true, text: t('common.confirm'), action: function () { return cancelPendingBurn(uuid); }, disabled: true },
                ],
            },
            custom: {
                type: DialogType.SIMPLE_WITH_CHECKBOX,
                message: t('pending-burn.cancel.confirm-message'),
                checkboxText: t('pending-burn.cancel.accept-terms'),
                checked: acceptTerms,
            },
        });
    }
    function cancelPendingBurn(uuid) {
        return __awaiter(this, void 0, void 0, function () {
            var error, result, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setServerLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, gqlSdk.BlockchainPendingBurnCancel({ input: { pendingBurnUuid: uuid } })];
                    case 2:
                        result = _a.sent();
                        if (!result.blockchainPendingBurnCancel.success) {
                            error = t('error.generic');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        if (err_1 instanceof Error) {
                            console.log("[cancelPendingBurn] ".concat(err_1));
                            error = t('error.generic');
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        if (!!error) return [3 /*break*/, 6];
                        return [4 /*yield*/, getPendingBurns()];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        setServerLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('pending-burn.cancel.title'),
                                close: { text: t('common.back'), action: hideDialog },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('pending-burn.cancel.success-message'),
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function hideDialog() {
        acceptTerms.setValue(false);
        setDialogProps(undefined);
    }
    if (!user || !user.magicLinkWalletAddress) {
        navigate(generateRoutePath(RoutePath.ROOT, {}));
        return null;
    }
    var labels = [
        {
            key: 'date',
            label: t('common.date'),
            align: CellAlign.LEFT,
        },
        {
            key: 'type',
            label: t('common.type'),
            align: CellAlign.LEFT,
            mobileSize: 0.5,
        },
        {
            key: 'target',
            label: t('common.target'),
            align: CellAlign.LEFT,
            mobileSize: 0.7,
        },
        {
            key: 'toBurn',
            label: t('common.to-burn'),
            align: CellAlign.CENTER,
            hiddenMobile: true,
        },
        {
            key: 'action',
            label: t('common.actions'),
            align: CellAlign.CENTER,
            actionCell: true,
        },
    ];
    var actions = [
        {
            icon: cancelIcon,
            label: t('common.cancel'),
            action: function (id) { return showCancelPendingBurnDialog(id); },
            withoutDesktopIcon: true,
        },
        {
            icon: burnIcon,
            label: t('common.burn'),
            warning: true,
            link: {
                routePath: RoutePath.PENDING_BURN,
                generateParams: function (id) {
                    return {
                        uuid: id,
                    };
                },
            },
        },
    ];
    var rows = pendingBurns
        ? pendingBurns.map(function (pendingBurn) {
            return {
                id: pendingBurn.uuid,
                data: {
                    date: {
                        type: CellType.TEXT,
                        value: formatDate(pendingBurn.createdAt, i18n.language),
                    },
                    type: { type: CellType.TEXT, value: t("pending-burn.type.".concat(getKeyFromEnum(pendingBurn.type))) },
                    target: { type: CellType.NUMBER, value: pendingBurn.targetTokenId || '-' },
                    toBurn: {
                        type: CellType.TEXT,
                        value: pendingBurn.tokenIdsToBurn.map(function (toBurn) { return toBurn.id; }).join(', '),
                    },
                },
            };
        })
        : [];
    return (_jsx(Layout, { children: _jsxs(_Fragment, { children: [_jsx(Header, { title: t('pending-burns.page-title') }), _jsx(Container, { children: pendingBurns && _jsx(Table, { actions: actions, labels: labels, rows: rows }) })] }) }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  padding: 48px;\n  width: 100%;\n\n  @media screen and (max-width: 824px) {\n    padding: 16px 16px 96px 16px;\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  padding: 48px;\n  width: 100%;\n\n  @media screen and (max-width: 824px) {\n    padding: 16px 16px 96px 16px;\n  }\n"])));
var templateObject_1;
